import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { parseAppt, formatAppt } from "@/lib/appt";

const KINDS = [["", "Not set"], ["time", "Set time"], ["window", "Window"], ["fcfs", "FCFS"], ["open", "Open"]];

// value/onChange use the canonical appointment string.
export const AppointmentInput = ({ value, onChange, disabled, flagged, testId }) => {
  const [p, setP] = useState(() => parseAppt(value));
  useEffect(() => { if (formatAppt(p) !== (value || "")) setP(parseAppt(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const set = (patch) => { const n = { ...p, ...patch }; setP(n); onChange(formatAppt(n)); };
  const ring = flagged ? "border-amber-400 bg-amber-50" : "";
  const showStart = ["time", "window", "fcfs"].includes(p.kind);
  const showEnd = p.kind === "window" || p.kind === "fcfs";
  return (
    <div className="flex gap-1.5 mt-0.5" data-testid={testId}>
      <select value={p.kind} disabled={disabled} onChange={(e) => set({ kind: e.target.value, ...(e.target.value === "open" || !e.target.value ? { start: "", end: "" } : {}) })}
        className={`h-9 rounded-md border border-input bg-transparent px-2 text-sm shadow-sm disabled:opacity-50 ${ring}`} data-testid={`${testId}-kind`}>
        {KINDS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {showStart && <Input type="time" value={p.start} disabled={disabled} onChange={(e) => set({ start: e.target.value })} className={`h-9 min-w-0 ${ring}`} aria-label="From" data-testid={`${testId}-start`} />}
      {showEnd && <Input type="time" value={p.end} disabled={disabled} onChange={(e) => set({ end: e.target.value })} className={`h-9 min-w-0 ${ring}`} aria-label="To" data-testid={`${testId}-end`} />}
    </div>
  );
};
